import React from "react";
import { useAuth, IDLE_WARN_SECONDS } from "@/lib/auth";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Clock, LogOut } from "lucide-react";

/**
 * Soft warning shown at 60s before hard logout. Uses idleSecondsLeft from
 * AuthProvider — pure countdown display, no side-effects.
 */
export default function IdleTimeoutModal() {
  const { user, idleSecondsLeft, stayActive, logout } = useAuth();
  const show = !!user && idleSecondsLeft > 0 && idleSecondsLeft <= IDLE_WARN_SECONDS;

  return (
    <Dialog open={show} onOpenChange={() => {}}>
      <DialogContent
        data-testid="idle-timeout-modal"
        className="rounded-none border-primary sm:max-w-md"
        onEscapeKeyDown={(e) => e.preventDefault()}
        onPointerDownOutside={(e) => e.preventDefault()}
      >
        <DialogHeader>
          <DialogTitle className="font-heading tracking-tight flex items-center gap-2">
            <Clock className="w-5 h-5 text-primary" />
            Your session is about to expire
          </DialogTitle>
        </DialogHeader>
        <div className="py-4 space-y-3">
          <div className="text-center">
            <div className="font-heading text-6xl text-primary" data-testid="idle-countdown">
              {idleSecondsLeft}
            </div>
            <div className="smin-label mt-1">seconds until automatic logout</div>
          </div>
          <p className="text-sm text-muted-foreground">
            For your security, SMIN automatically signs you out after 30 minutes
            of inactivity. Click <span className="font-mono text-foreground">Stay signed in</span>
            to keep working.
          </p>
        </div>
        <div className="flex items-center justify-between gap-3 pt-2 border-t border-border">
          <Button
            variant="outline"
            onClick={() => logout()}
            data-testid="idle-logout-now"
            className="rounded-none font-mono text-xs uppercase tracking-widest"
          >
            <LogOut className="w-3.5 h-3.5 mr-1.5" /> Sign out now
          </Button>
          <Button
            onClick={stayActive}
            data-testid="idle-stay-signed-in"
            className="rounded-none font-heading tracking-tight"
          >
            Stay signed in
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
